import { fromFetch } from 'rxjs/fetch';

import { PagedCollectionParams } from '../../../models/paged-collection-params';
import { requiredHeaders } from '../../../models/required-headers';
import { createPagedCollectionSchema } from '../../../utils/create-paged-collection-schema';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { partnerBundleEnvironment } from '../partner-bundle-environment';
import { bundleSchema } from '../schemas/bundle.schema';

/**
 * Returns a paginated response of Bundles
 * @param params Paged Collection Params
 * @returns Paged Collection of Bundles
 */
export function getBundles(this: unknown, params?: PagedCollectionParams) {
  const requestUrl = `${partnerBundleEnvironment.resolve(this).bundlesUrl}?${
    params ? params.urlParams : ''
  }`;

  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(requestUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(selectData(createPagedCollectionSchema(bundleSchema)));
}
